<template>
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon1">
        <font-awesome-icon :icon="['fas', 'search']" />
      </span>
      <input
        type="text"
        class="form-control"
        placeholder="Buscar en tarea..."
        aria-label="Buscar en tarea..."
        aria-describedby="basic-addon1"
        :value="busquedaTareas"
        @input="$emit('update:busquedaTareas', $event.target.value)"
      />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      busquedaTareas: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  